<div class="internal-server-page">
  <div class="internal-server-page__inner">
    <a role="link" href="/" id="OhGarLink" class="ohgar-link">Oh'Gar</a>
    <div class="internal-server-page__wrapper-box">
      <div class="internal-server-page__box">
        <h1>{{ 'internalServer.vaya' | cxTranslate }}</h1>
        <p>{{ 'internalServer.errorText' | cxTranslate }}</p>
        <p>{{ 'internalServer.pleaseClean' | cxTranslate }}</p>
        <p><a href="/">{{ 'internalServer.tryAgain' | cxTranslate }}</a></p>
        <div>{{ 'internalServer.ifNoDontForget' | cxTranslate }}</div>
      </div>
    </div>
  </div>
</div>
